import { render } from "./ReportAlert.vue?vue&type=template&id=4800e722"
import script from "./ReportAlert.vue?vue&type=script&lang=js"
export * from "./ReportAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__